import { NetworkConfigType } from '../types';

// ABI
import ERC20TOKENABI from './contracts/testnet/ERC20.json';
import TokenXABI from './contracts/testnet/TokenX.json';
import TokenStakeManagerABI from './contracts/testnet/Staking.json';
import RewardsABI from './contracts/testnet/Rewards.json';

const providerKey = process.env.NEXT_PUBLIC_ALCHEMY_KEY || '';

export const TestNetConfig: NetworkConfigType = {
  chainId: '0x5',
  supportedChainIDs: [5],
  providerKey,
  chainName: 'Ethereum Testnet',
  nativeCurrency: {
    name: 'Stader',
    symbol: 'SD',
    xsymbol: 'xSD',
    decimals: 18,
  },
  rpcUrls: {
    default: `https://eth-goerli.g.alchemy.com/v2`,
  },
  blockExplorerUrls: ['https://goerli.etherscan.io'],
  contractAddresses: {
    erc20: '0xD311878a010a94e4500eb5B056DfeaEcAc349AD2', // Token
    xtoken: {
      token: '0x1b645b2Ba5Ea35D4b83537c3839780eD241c0Cd2',
      stakingContract: '0x6FC6Ef1B6f9d7e20c37B56CB827eC7a04C35Bd3b',
      rewardsContract: '0xB432ABa2b6548090B53afB0c6e80c287E912c267',
    },
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXABI,
      stakingContract: TokenStakeManagerABI,
      rewardsContract: RewardsABI,
    },
  },
};
